var getAttachments_gql_default = `
query GetAttachments($id: [Int]) {
  ProductAttachments(id: $id) {
    productattach_id
    file
    file_ext
    name
    url
  }
}
`;
export {
  getAttachments_gql_default as default
};
